var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.25C6.58579 7.25 6.25 7.58579 6.25 8C6.25 8.41421 6.58579 8.75 7 8.75H17C17.4142 8.75 17.75 8.41421 17.75 8C17.75 7.58579 17.4142 7.25 17 7.25H7Z",
    fill: "#00322E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12C6.25 11.5858 6.58579 11.25 7 11.25H17C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.4142 17.4142 12.75 17 12.75H7C6.58579 12.75 6.25 12.4142 6.25 12Z",
    fill: "#00322E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.25C6.58579 15.25 6.25 15.5858 6.25 16C6.25 16.4142 6.58579 16.75 7 16.75H17C17.4142 16.75 17.75 16.4142 17.75 16C17.75 15.5858 17.4142 15.25 17 15.25H7Z",
    fill: "#00322E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.053 1.62867C9.60734 1.29232 8.99266 1.29232 8.54699 1.62867L6.65 3.06036L5.25301 2.00603C4.42944 1.38447 3.25 1.97197 3.25 3.00376V20.9597C3.25 22.0078 4.46242 22.5905 5.28087 21.9358L6.52562 20.94L8.5681 22.3989C9.0092 22.714 9.6031 22.7088 10.0387 22.3862L11.9915 20.9397L13.8407 22.3622C14.2867 22.7052 14.9068 22.708 15.3559 22.3691L17.2583 20.9334L18.7648 22.029C19.591 22.6299 20.75 22.0397 20.75 21.0181V2.98187C20.75 1.96026 19.591 1.37007 18.7648 1.97095L17.2583 3.0666L15.353 1.62867C14.9073 1.29232 14.2927 1.29232 13.847 1.62867L11.95 3.06036L10.053 1.62867ZM12.703 4.3713L14.6 2.93961L16.5025 4.37546C16.9416 4.70688 17.5458 4.71223 17.9907 4.38865L19.25 3.47281V20.5272L17.9907 19.6113C17.5458 19.2877 16.9416 19.2931 16.5025 19.6245L14.6043 21.0571L12.7565 19.6357C12.3138 19.2952 11.699 19.2896 11.2503 19.622L9.29198 21.0726L7.24363 19.6095C6.78854 19.2844 6.17291 19.3012 5.73621 19.6506L4.75 20.4395V3.50565L5.89699 4.3713C6.34266 4.70766 6.95734 4.70766 7.40301 4.3713L9.3 2.93961L11.197 4.3713C11.6427 4.70766 12.2573 4.70766 12.703 4.3713Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCoupon);
export default __webpack_public_path__ + "static/media/icn_coupon.55dcdf418e96d21bf9c991373b8c182f.svg";
export { ForwardRef as ReactComponent };